const defaultConfig = {
    mcsApi: '/mcsApi',
    outboundApi: '/outboundApi',
    inboundApi: '/inboundApi',
    reportApi: '/reportApi',
    asyncExportApi: '/asyncExportApi',
    stockApi: '/stockApi',
    invopApi: '/invopApi',
    api: '/api',
    taskWebApi: '/taskWebApi',
}
const UAT2 = {
    mcsApi: '//sg-iwms-mcs-pre2.jd.com',
    outboundApi: '//sg-iwms-outbound-pre2.jd.com',
    inboundApi: '//sg-iwms-inbound-pre2.jd.com',
    reportApi: '//sg-iwms-smartquery-pre2.jd.com',
    asyncExportApi: '//sg-iwms-smartquery-pre2.jd.com',
    stockApi: '//sg-iwms-stock-pre2.jd.com',
    invopApi: '//sg-iwms-invop-pre2.jd.com',
    api: '//sg-libra-pre.jd.com/api',
    taskWebApi: '//sg-libra-pre.jd.com',

}

const SG_GRAY = {
    mcsApi: '//sg-iwms-mcs-gray.jd.com',
    outboundApi: '//sg-iwms-outbound-gray.jd.com',
    inboundApi: '//sg-iwms-inbound-gray.jd.com',
    reportApi: '//sg-iwms-smartquery-gray.jd.com',
    asyncExportApi: '//sg-iwms-smartquery-gray.jd.com',
    stockApi: '//sg-iwms-stock-gray.jd.com',
    invopApi: '//sg-iwms-invop-gray.jd.com',
    api: '//sg-libra.jd.com/api',
    taskWebApi: '//sg-libra.jd.com',
}

const SG = {
    mcsApi: '//sg-iwms-mcs.jd.com',
    outboundApi: '//sg-iwms-outbound.jd.com',
    inboundApi: '//sg-iwms-inbound.jd.com',
    reportApi: '//sg-iwms-smartquery.jd.com',
    asyncExportApi: '//sg-iwms-smartquery.jd.com',
    stockApi: '//sg-stock.jd.com',
    invopApi: '//sg-iwms-invop.jd.com',
    api: '//sg-libra.jd.com/api',
    taskWebApi: '//sg-libra.jd.com',
}

const GG_GRAY = {
    mcsApi: '//gg-iwms-mcs-gray.jd.com',
    outboundApi: '//us-iwms-outbound-gray.jd.com',
    inboundApi: '//gg-iwms-inbound-gray.jd.com',
    reportApi: '//us-iwms-smartquery-gray.jd.com',
    asyncExportApi: '//us-iwms-smartquery-gray.jd.com',
    stockApi: '//us-iwms-stock-gray.jd.com',
    invopApi: '//gg-iwms-invop-gray.jd.com',
    api: '//sg-libra.jd.com/api',
    taskWebApi: '//sg-libra.jd.com',
}

const GG = {
    mcsApi: '/mcsApi',
    outboundApi: '/outboundApi',
    inboundApi: '/inboundApi',
    reportApi: '/reportApi',
    asyncExportApi: '/asyncExportApi',
    stockApi: '/stockApi',
    invopApi: '/invopApi',
    api: '/api',
    taskWebApi: '/taskWebApi',
}

const EU_GRAY = {
    mcsApi: '//eu-iwms-master-gray.jd.com',
    outboundApi: '//eu-iwms-outbound-gray.jd.com',
    inboundApi: '//eu-iwms-inbound-gray.jd.com',
    reportApi: '//eu-iwms-smartquery-gray.jd.com',
    asyncExportApi: '//eu-iwms-smartquery-gray.jd.com',
    stockApi: '//eu-iwms-stock-gray.jd.com',
    invopApi: '//eu-iwms-invop-gray.jd.com',
    api: '//eu-libra.jd.com/api',
    taskWebApi: '//eu-libra.jd.com',
}

const EU = {
    mcsApi: "//eu-iwms-master.jd.com",
    outboundApi: "//eu-iwms-outbound.jd.com",
    inboundApi: "//eu-iwms-inbound.jd.com",
    reportApi: "//eu-iwms-smartquery.jd.com",
    asyncExportApi: "//eu-iwms-smartquery.jd.com",
    stockApi: "//eu-iwms-stock.jd.com",
    invopApi: "//eu-iwms-invop.jd.com",
    api: "//eu-libra.jd.com/api",
    taskWebApi: "//eu-libra.jd.com",   
}

const configs  = {
    UAT2,
    SG_GRAY,
    SG,
    GG_GRAY,
    GG,
    EU_GRAY,
    EU
}

const isnovaEnv = {
    defaultConfig: 'as-yf',
    SG_GRAY: 'as',
    SG: 'as',
    GG_GRAY: 'us',
    GG: 'us',
    EU_GRAY: 'eu',
    EU: 'eu'
}

export default function getPrefix() {
    const env = window.APP_ENV
    let config = configs[env] || defaultConfig
    // 需要判断是否是ochama
    if(window.location.hostname.indexOf('ochama.com') > -1 || window.location.hostname.indexOf('iwms-eu1.jd.com') > -1){
        config = defaultConfig
    }else if(window.location.hostname.indexOf('jdlglobal.com') > -1 && env === 'GG_GRAY'){
        // config = defaultConfig
        // if(env === 'GG') config.mcsApi = '//mcs.us.jdlglobal.com'
        // else  if(env === 'GG_GRAY') config.mcsApi = '//iwms-mcs-gray.us.jdlglobal.com'
        config = defaultConfig
        config.mcsApi = '//iwms-mcs-gray.us.jdlglobal.com'
    }
    console.log(config)
    return config
}

export const getIsnovaEnv = () => {
    const env = isnovaEnv[window.APP_ENV]
    console.log("🚀 ~ getIsnovaEnv ~ env:", env)
    console.log("🚀 ~ getIsnovaEnv ~ window.APP_ENV:", window.APP_ENV)
    console.log("🚀 ~ getIsnovaEnv ~ isnovaEnv[defaultConfig]:", isnovaEnv[defaultConfig])
    return env?env:isnovaEnv.defaultConfig
}

